import React from 'react';
import { Chip } from '@mui/material';

/**
 * 사용자 권한 셀 컴포넌트
 * 
 * 사용자 권한을 Chip으로 표시합니다.
 * 
 * @param {Object} params - DataGrid의 renderCell 파라미터
 * @param {Object} params.row - 행 데이터
 * @param {string} params.row.type - 사용자 권한 (관리자, 교육운영자, FT, 교육생)
 */
const UserTypeCell = ({ row }) => {
  // 권한별 뱃지 색상 구분
  const colorMap = { 
    STUDENT: { label: '교육생', color: 'success' },
    FACILITATOR: { label: 'FT', color: 'warning' },
    ADMIN: { label: '관리자', color: 'error' },
    OPERATOR: { label: '교육운영자', color: 'primary' },
  };
  
  return (
    <Chip
      label={colorMap[row.userRole]?.label || row.userRole}
      size="small"
      color={colorMap[row.userRole]?.color || 'default'}
      variant="outlined"
    />
  );
};

export default UserTypeCell;
